function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Link } from "@custom/schema";
import { AnimatePresence, motion, useMotionValueEvent, useScroll, useSpring } from "motion/react";
import React, { Fragment, useState } from "react";
import { ArrowUp, ChevronRight } from "react-feather";
import { useTranslation } from "react-i18next";
import { getLocalizedUrl } from "../../../utils/url";
import { HeaderCTAs } from "./HeaderCTAs";
export var useBreadcrumbs = function useBreadcrumbs(breadcrumbs) {
  return breadcrumbs.reduce(function (acc, value, index, array) {
    if (array.length === 1) {
      return _to_consumable_array(acc);
    }
    return _to_consumable_array(acc).concat([_object_spread_props(_object_spread({}, value), {
      isCurrent: index === array.length - 1
    })]);
  }, []);
};
export var Breadcrumbs = function Breadcrumbs(param) {
  var initialBreadcrumbs = param.breadcrumbs;
  var t = useTranslation().t;
  var _useState = _sliced_to_array(useState(false), 2),
    showAll = _useState[0],
    setShowAll = _useState[1];
  var breadcrumbs = initialBreadcrumbs || [{
    text: "Home",
    url: "/"
  }];
  var transformedBreadcrumbs = useBreadcrumbs(breadcrumbs);
  var currentItem = transformedBreadcrumbs.find(function (breadcrumb) {
    return breadcrumb.isCurrent;
  });
  var CurrentItemWrapper = (currentItem === null || currentItem === void 0 ? void 0 : currentItem.url) ? "span" : Link;
  var visibleBreadcrumbs = showAll ? transformedBreadcrumbs : transformedBreadcrumbs.length > 3 ? transformedBreadcrumbs.slice(-3) : transformedBreadcrumbs;
  var _currentItem_url;
  return /*#__PURE__*/React.createElement("nav", {
    className: "flex flex-row gap-2 items-center flex-wrap"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, t("You are here")), /*#__PURE__*/React.createElement("ol", {
    className: "flex flex-row gap-2 items-center flex-wrap"
  }, transformedBreadcrumbs.length > 3 && !showAll && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setShowAll(true);
    },
    className: "text-primary-black/40 font-bold font-juneau text-16 leading-125% hover:text-theme-dark transition-colors duration-300 ease-in-out rounded-1.25 min-w-fit"
  }, "\xb7\xb7\xb7")), /*#__PURE__*/React.createElement(ChevronRight, {
    className: "w-4 h-4 min-w-4 min-h-4 text-primary-black",
    "aria-hidden": "true"
  })), visibleBreadcrumbs.map(function (param) {
    var url = param.url,
      text = param.text,
      isCurrent = param.isCurrent;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: text.replace(/\s+/g, "-").toLowerCase()
    }, !isCurrent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
      className: "flex"
    }, /*#__PURE__*/React.createElement(Link, {
      href: getLocalizedUrl({
        to: url || "/"
      }).url,
      className: "text-primary-black font-bold font-juneau text-16 leading-125% hover:text-theme-dark transition-colors duration-300 ease-in-out rounded-1.25  min-w-fit"
    }, text)), /*#__PURE__*/React.createElement(ChevronRight, {
      className: "w-4 h-4 min-w-4 min-h-4 text-primary-black",
      "aria-hidden": "true"
    })));
  }), currentItem && /*#__PURE__*/React.createElement("li", {
    className: "flex"
  }, /*#__PURE__*/React.createElement(CurrentItemWrapper, {
    href: getLocalizedUrl({
      to: (_currentItem_url = currentItem.url) !== null && _currentItem_url !== void 0 ? _currentItem_url : "/"
    }).url,
    className: "text-theme-dark font-bold font-juneau text-16 leading-100% rounded-1.25 min-w-fit "
  }, currentItem.text))));
};
export var HeaderSticky = function HeaderSticky(param) {
  var _param_breadcrumbs = param.breadcrumbs,
    breadcrumbs = _param_breadcrumbs === void 0 ? [] : _param_breadcrumbs,
    _param_hideHeader = param.hideHeader,
    hideHeader = _param_hideHeader === void 0 ? false : _param_hideHeader,
    _param_hideCallToActionInHeader = param.hideCallToActionInHeader,
    hideCallToActionInHeader = _param_hideCallToActionInHeader === void 0 ? false : _param_hideCallToActionInHeader;
  var scrollYProgress = useScroll({
    offset: ["150px", "end"]
  }).scrollYProgress;
  var scrollYProgressAnimated = useSpring(scrollYProgress, {
    stiffness: 100,
    bounce: 0,
    mass: 0.1,
    duration: 0.25
  });
  var _useState = _sliced_to_array(useState(false), 2),
    isVisible = _useState[0],
    setIsVisible = _useState[1];
  useMotionValueEvent(scrollYProgress, "change", function (current) {
    if (current > 0) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }, /*#__PURE__*/React.createElement(AnimatePresence, null, isVisible && /*#__PURE__*/React.createElement(motion.div, {
    "data-testid": "sticky-header",
    className: "px-10 fixed top-0 inset-x-0 z-50",
    initial: {
      opacity: 0,
      y: -100
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: -100
    },
    transition: {
      duration: 0.4,
      ease: "easeInOut",
      type: "spring",
      bounce: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content bg-primary-white py-4 pe-5 ps-10 rounded-b-7.5 relative shadow-sticky-header"
  }, /*#__PURE__*/React.createElement(motion.div, {
    id: "scroll-indicator",
    className: "absolute top-0 left-0 right-0 h-1 bg-theme-dark origin-left",
    style: {
      scaleX: scrollYProgressAnimated
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row justify-between items-center gap-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center gap-10"
  }, /*#__PURE__*/React.createElement("button", {
    className: "p-2 rounded-full text-theme-dark hover:text-primary-white hover:bg-theme-dark bg-primary-white transition-colors duration-300 ease-in-out border-2 border-theme-dark hover:border-primary-white border-solid",
    onClick: function onClick() {
      window.scrollTo({
        behavior: "smooth",
        top: 0
      });
    },
    "aria-label": "Scroll to top"
  }, /*#__PURE__*/React.createElement(ArrowUp, {
    className: "w-5 h-5",
    "aria-hidden": "true"
  })), breadcrumbs && breadcrumbs.length > 0 && !hideHeader && /*#__PURE__*/React.createElement(Breadcrumbs, {
    breadcrumbs: breadcrumbs
  })), /*#__PURE__*/React.createElement(HeaderCTAs, {
    hideHeader: hideHeader,
    hideCallToActionInHeader: hideCallToActionInHeader,
    variant: "dark"
  }))))));
};